import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import NewsPage from "@/pages/news/page";
import NewsDetailPage from "@/pages/news/detail/page";
import ActivitiesPage from "@/pages/activities/page";
import AnnouncementsPage from "@/pages/announcements/page";
import AboutPage from "@/pages/about/page";
import ContactPage from "@/pages/contact/page";
import AdminPage from "@/pages/admin/page";
import PagarPage from "@/pages/pagar/page";
import Layout from "@/components/feature/Layout";

const routes: RouteObject[] = [
  {
    element: <Layout />,
    children: [
      { path: "/", element: <Home /> },
      { path: "/noticias", element: <NewsPage /> },
      { path: "/noticias/:id", element: <NewsDetailPage /> },
      { path: "/actividades", element: <ActivitiesPage /> },
      { path: "/comunicados", element: <AnnouncementsPage /> },
      { path: "/sobre-el-apr", element: <AboutPage /> },
      { path: "/contacto", element: <ContactPage /> },
      { path: "/admin", element: <AdminPage /> },
      { path: "/pagar", element: <PagarPage /> },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
